/* eslint-disable camelcase */
const normalizeMetafield = (values) => {
  const { metadata_attributes, ...valuesWithoutMetadata } = values;

  if (!metadata_attributes) {
    return valuesWithoutMetadata;
  }

  const metafieldsKeys = Object.keys(metadata_attributes);
  const metafieldsNormalized = metafieldsKeys.reduce((currentMetafieldArray, metafieldKey) => {
    const isArray = Array.isArray(metadata_attributes[metafieldKey]);
    const metafieldValue = isArray
      ? values.metadata_attributes[metafieldKey].toString()
      : values.metadata_attributes[metafieldKey];

    return { ...currentMetafieldArray, [metafieldKey]: metafieldValue };
  }, []);

  return { ...valuesWithoutMetadata, metadata_attributes: metafieldsNormalized };
};

export default normalizeMetafield;
